'use strict';

(function () {
    const self = Fotobook.qualityCheck = {
        MM_PER_INCH: 25.4,
        QUALITY_RESERVE: 0.99,

        ENABLE_CHECK_QUALITY_ON_FRONT: true,
        CLASSES_TO_CHECK: '.foto-container, .bg-content, .artefact-container',

        QUALITY_STATUS_OK: 0,
        QUALITY_STATUS_LOW_RESOLUTION: 1,
        QUALITY_STATUS_ORIGINAL_MISSING: 3,

        TEMPLATE_BACKGROUND_WARNING: [
            '<div class="bg-attention bg-attention-no-original ajax-tooltip" data-qtip-selector="photobook-tooltipText-noOrigBg"></div>',
            '<div class="bg-attention bg-attention-low-quality ajax-tooltip" data-qtip-selector="photobook-tooltipText-lowQualityBg"></div>',
        ].join(''),

        /**
         * Пометка контейнеров с низким качеством. Пустые метить не нужно - у них и так есть нужный класс
         */
        qualityCheck(qualityCheck) {
            for (const i in qualityCheck.containers) {
                if (Object.prototype.hasOwnProperty.call(qualityCheck.containers, i)) {
                    const r = qualityCheck.containers[i];
                    let $cont = $(Fotobook.book.getContainerSelector(i));

                    if ($cont.hasClass('bg-content')) {
                        $cont = $cont.add($cont.closest('.bg'));
                    }

                    // для проверки фото на битость нужны признаки, так при установке фото в контейнер
                    // выставляется соответствующий класс - опираемся на него
                    //
                    // битое фото имеет более высокий приоритет, низкое качество игнорим
                    if (!$cont.hasClass('no-original')) {
                        $cont.toggleClass('low-quality-container', r === self.QUALITY_STATUS_LOW_RESOLUTION);
                    }
                }
            }

            if ($('html').hasClass('toggle-pages-list-outer display-book-errors')) {
                $(Fotobook.book.pagesList).find('.carousel-item').each(function () {
                    Fotobook.book.showCarouselWarnings.call($(this));
                });
            }
        },

        /** Проверка качества контейнеров */
        checkContainersQuality($containers) {
            for (let i = 0, len = $containers.length; i < len; i++) {
                if (!Object.prototype.hasOwnProperty.call($containers, i)) {
                    continue;
                }
                self.checkContainerQuality($containers[i]);
            }
        },

        /** Проверка качества одного контейнера */
        checkContainerQuality(cont) {
            let $cont = $(cont);
            const countImages = $cont.find('.foto-image, .bg-image').length;

            if (!countImages && !$cont.hasClass('artefact-container')) {
                return;
            }

            const containerSizes = self.getMaxSize($cont);

            let contWidth;
            let contHeight;

            if ($cont.hasClass('bg-content')) {
                $cont = $cont.find('.bg-image');
                contWidth = Math.floor(parseInt($cont.closest('.book-page').attr('data-page-width'), 10));
                contHeight = Math.floor(parseInt($cont.closest('.book-page').attr('data-page-height'), 10));
            } else {
                contWidth = Math.floor(parseInt($cont.attr('data-width'), 10));
                contHeight = Math.floor(parseInt($cont.attr('data-height'), 10));
            }

            const containers = {};
            let qualityCheck = {};

            containers[containerSizes.id] = self.QUALITY_STATUS_OK;
            if (contWidth * this.QUALITY_RESERVE > containerSizes.maxAllowedWidthInPx ||
                contHeight * this.QUALITY_RESERVE > containerSizes.maxAllowedHeightInPx) {
                containers[containerSizes.id] = self.QUALITY_STATUS_LOW_RESOLUTION;
                this.showByContainerId(containerSizes.id);
            }

            self.qualityCheck(qualityCheck = {
                containers,
            });
        },

        /**
         * Выводим сообщение о качестве фоток по id контейнера. Контейнер может быть группой, поэтому выбираем его
         * и всех его потомков. Иногда приходится передавать полный стейт, эта функция помогает проверить только нужное
         */
        showByContainerId(ids) {
            setTimeout(() => {
                let elements;
                let message = null;
                // Ищем среди самих элементов, а также среди всего содержимого групп
                elements = $(Fotobook.book.getContainerSelector(ids));
                elements = elements.add(elements.filter('.page-container')).filter('.low-quality-container');
                if (elements.filter(self.CLASSES_TO_CHECK).length) {
                    message = t('photobook-js-messagePhotoPoorQuality');
                } else if (elements.filter('.artefact-container').length) {
                    message = t('photobook-js-messageArtefactPoorQuality');
                }
                if (message) {
                    Fotobook.notification.showWarning(message);
                }
            }, 0);
        },

        /**
         * При редактировании фотографии, нужно проверить контейнеры (в том числе фоны)
         * только с этой фоткой и вывести результат
         */
        showByFotoId(id) {
            setTimeout(() => {
                const elements = $(`.foto_${id}`).add(`.bg-clipart-foto[data-id="${id}"]`).closest('.low-quality-container');
                if (elements.length) {
                    Fotobook.notification.showWarning(t('photobook-js-messagePhotoPoorQuality'));
                }
            }, 100);
        },

        getDPM() {
            const product = Fotobook.book.product;
            const dpiPhoto = product.dpi_foto_min || product.dpi_resolution;
            return dpiPhoto / this.MM_PER_INCH;
        },

        /**
         * Получение максимально-разрешенного размера качества контейнера
         */
        getMaxSize(cont) {
            const $cont = $(cont);
            const id = parseInt($cont.data('id'), 10);
            const $contSelector = $(Fotobook.book.getContainerSelector(parseInt(id, 10)));
            let image = $contSelector.find('.foto-image, .bg-image, .artefact-image').data();
            const fotobookInitial = $cont.data('fotobookInitial');
            const $page = fotobookInitial ? $('#book').find(`.page_${fotobookInitial.page_id}`) : $cont.closest('.book-page');

            return {
                ...{ id },
                ...this.getMaxAllowedQualitySize(image, $page),
            };
        },

        getMaxAllowedQualitySize(imageData, $page) {
            const dpm = this.getDPM();
            const pageWidth = $page.data('pageWidth');
            const region = $page.data('page_type');
            const displayRegion = Fotobook.displayRegions.getRegion(region);
            const regionTypeOriginWidth = displayRegion.orig_width;

            let imageWidth = imageData.width;
            let imageHeight = imageData.height;

            if (typeof imageData.crop_width !== 'undefined') {
                imageWidth *= imageData.crop_width / 100;
            }
            if (typeof imageData.crop_height !== 'undefined') {
                imageHeight *= imageData.crop_height / 100;
            }

            // считаем, во сколько раз наша страница проекта увеличится уже для макета
            const coefficientPageWidth = dpm * regionTypeOriginWidth / pageWidth;
            // получаем из размеров оригинального изображения нужную ширину
            const maxAllowedWidthInPx = Math.floor(imageWidth / coefficientPageWidth);
            // и пропорционально - высоту
            const maxAllowedHeightInPx = Math.floor(maxAllowedWidthInPx / imageWidth * imageHeight);

            return {
                maxAllowedHeightInPx,
                maxAllowedWidthInPx,
            };
        },

        /** проверить контейнеры на текущем развороте */
        checkContainersOnPage() {
            new Promise(resolve => resolve(1))
                .then(() => {
                    const $book = $(Fotobook.book.book);
                    $book.find('.book-page').each((index, page) => {
                        self.pageAddWarningTemplate($(page));
                    });
                    const $containers = $book.find(self.CLASSES_TO_CHECK).not('.empty'); // .low-quality-container
                    self.checkContainersQuality($containers);
                });
        },

        /** Добавить страницам структуры для отображения уведомлений если нужны */
        pageAddWarningTemplate($page) {
            if (
                !$page.hasClass('flyleaf-page') &&
                !$page.find('.bg_attention').length && // темплейт уже добавлен
                $page.find('.bg-clipart-foto').length // фото из темы игнорируем
            ) {
                $page.find('.bg').append([self.TEMPLATE_BACKGROUND_WARNING]);
            }
        },

        markSpreadsWithErrors() {
            if (!$(':root').hasClass('display-book-errors')) {
                return;
            }
            const $spreads = $('.carousel-pages-list').find('.carousel-item');
            $spreads.each((spreadIndex, spread) => {
                const $spread = $(spread);
                const $pages = $spread.find('.book-page');
                let countErrors = 0;
                $pages.each((pageIndex, page) => {
                    countErrors += Fotobook.book.showCarouselWarnings.call($(page));
                });
                countErrors ? $spread.addClass('has-errors') : $spread.removeClass('has-errors');
            });
        },
    };

    $(document)
        .on(Fotobook.events.MODIFIED, () => {
            self.checkContainersOnPage();
        })
        .on(Fotobook.events.PROJECT_CONTENT_CHANGED, () => {
            self.checkContainersOnPage();
            self.markSpreadsWithErrors();
        });
})();
